// De weekweergave met de rijen links en de dagen horizontaal (resourceTimeline)
// is een betaald onderdeel van FullCalendar. Zonder geldige sleutel tekent
// FullCalendar er een waarschuwing overheen, en die hoort geen enkele klant te
// zien.
//
// Daarom is de sleutel de poort: staat hij er niet, dan verschijnt de knop naar
// die weergave niet en verandert er voor niemand iets. Dat valt dus dicht en
// niet open. De sleutel is een bouwinstelling (REACT_APP_...), geen waarde uit
// Firestore, dus er is geen moment waarop hij 'nog aan het laden' is.
// AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading

/** Leeg zolang de licentie niet gekocht en gezet is. */
const FULLCALENDAR_LICENSE_KEY = (process.env.REACT_APP_FULLCALENDAR_LICENSE_KEY || '').trim()

/**
 * @returns {boolean} Of de betaalde weergaven aangeboden mogen worden
 */
const hasSchedulerLicense = () => FULLCALENDAR_LICENSE_KEY !== ''

export { FULLCALENDAR_LICENSE_KEY, hasSchedulerLicense }
export default hasSchedulerLicense
